export const CONSENT_COOKIE_NAME = "reabel_consent";
export const CONSENT_COOKIE_VERSION = 1;
export const CONSENT_COOKIE_MAX_AGE_SECONDS = 90 * 24 * 60 * 60;

export const DEFAULT_CONSENT_FLAGS = {
  externalMedia: false,
  analytics: false,
};

const readCookieValue = (cookieName) => {
  if (typeof document === "undefined") return null;
  const prefix = `${cookieName}=`;
  const parts = document.cookie ? document.cookie.split(";") : [];
  for (const part of parts) {
    const trimmed = part.trim();
    if (trimmed.startsWith(prefix)) {
      return trimmed.slice(prefix.length);
    }
  }
  return null;
};

const normalizeFlags = (flags) => ({
  externalMedia: Boolean(flags?.externalMedia),
  analytics: false,
});

export const readConsentCookie = () => {
  const raw = readCookieValue(CONSENT_COOKIE_NAME);
  if (!raw) return null;
  try {
    const parsed = JSON.parse(decodeURIComponent(raw));
    return {
      version: Number(parsed?.v) || CONSENT_COOKIE_VERSION,
      flags: normalizeFlags({
        externalMedia: parsed?.em === 1 || parsed?.em === true,
        analytics: false,
      }),
      timestamp:
        typeof parsed?.ts === "string" && parsed.ts.trim()
          ? parsed.ts
          : new Date().toISOString(),
    };
  } catch {
    return null;
  }
};

export const writeConsentCookie = (flags) => {
  if (typeof document === "undefined") return null;

  const normalized = normalizeFlags(flags);
  const payload = {
    v: CONSENT_COOKIE_VERSION,
    em: normalized.externalMedia ? 1 : 0,
    an: 0,
    ts: new Date().toISOString(),
  };
  const encoded = encodeURIComponent(JSON.stringify(payload));
  const secure =
    typeof window !== "undefined" && window.location.protocol === "https:"
      ? "; Secure"
      : "";

  document.cookie =
    `${CONSENT_COOKIE_NAME}=${encoded}; Max-Age=${CONSENT_COOKIE_MAX_AGE_SECONDS}; ` +
    `Path=/; SameSite=Lax${secure}`;

  return {
    version: payload.v,
    flags: normalized,
    timestamp: payload.ts,
  };
};
